import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {QuickMessage} from './src';
export class QuickMessageModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [BrowserModule, FormsModule],
    declarations: [QuickMessage],
    exports: [QuickMessage]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function QuickMessageModule_tsickle_Closure_declarations() {
/** @type {?} */
QuickMessageModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
QuickMessageModule.ctorParameters;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
